import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import TextField from "@mui/material/TextField";
import { db } from "../../firebase";

function DropDownSpecificStaffV2(props) {
  const [allStaff, setAllStaff] = useState([]);

  useEffect(() => {
    const roleCollection = collection(db, "roles");
    const unsubscribe = onSnapshot(roleCollection, (querySnapshot) => {
      setAllStaff(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const handleChange = (event) => {
    props.onChange(event.target.value);
  };

  const renderOptions = () => {
    // Filter roles according to allowedRoles passed in props
    const filteredStaff = props.allowedRoles
      ? allStaff.filter((staff) => props.allowedRoles.includes(staff.role))
      : allStaff;

    filteredStaff.sort((a, b) => a.displayName.localeCompare(b.displayName));

    return (
      <>
        <option value="">--Choose--</option>
        {filteredStaff.map((staff) => (
          <option key={staff.id} value={staff.displayName}>
            {`${staff.displayName} - ${staff.role}`}
          </option>
        ))}
      </>
    );
  };

  return (
    <div className="input-label-container-v2">
      <div
        style={{
          color: "#a0a0a0",
          fontWeight: "500",
          fontSize: "12px",
          textTransform: "uppercase",
          paddingBottom: "2px",
        }}
      >
        {props.title}
        {props.isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
      <TextField
        className="dropdown-select"
        SelectProps={{
          native: true,
          style: { height: 40 },
        }}
        select
        value={props.value}
        onChange={handleChange}
        style={{
          background: "#fafafa",
          fontWeight: "500",
          fontSize: "16px",
          width: props.width,
        }}
        error={props.error}
        helperText={props.helperText}
      >
        {renderOptions()}
      </TextField>
    </div>
  );
}

export default DropDownSpecificStaffV2;
